import React, { useState } from 'react';
import img from "../src/assets/wishes.jpeg";

const ImageSection = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'relative',
      padding: '32px 24px 24px',
      maxWidth: '960px',
      margin: '0 auto',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      border: '1px solid #e5e7eb',
    }}>

      {/* Close button — top right of the section */}
      <button
        onClick={() => setIsVisible(false)}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          width: '34px',
          height: '34px',
          backgroundColor: '#dc2626',
          border: '2px solid #ffffff',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 3px 8px rgba(0,0,0,0.25)',
          padding: 0,
          zIndex: 10,
        }}
        aria-label="Close"
      >
        <svg width="16" height="16" fill="none" stroke="white" strokeWidth="3" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Single centered image */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <img
          src={img}
          alt="25 Years celebration"
          style={{
            width: '100%',
            maxWidth: '600px',
            height: '320px',
            objectFit: 'contain',
            borderRadius: '10px',
            border: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            padding: '10px',
          }}
        />
      </div>

    </div>
  );
};

export default ImageSection;